import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect, } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';
import { ApiService } from '../../services/api.service';
import { Store } from '@ngrx/store';
import { IAppState } from '../app.state';
import { CreateInstituciones, CreateInstitucionesSuccess, DeleteInstituciones, DeleteInstitucionesSuccess, GetInstituciones, GetInstitucionesSuccess, UpdateInstituciones, UpdateInstitucionesSuccess } from '../actions/instituciones.actions';
import { IDeleteInstitucionesResponse, IInstituciones, IUpdateInstitucionesResponse } from 'src/app/interfaces/instituciones.interface';


@Injectable()
export class InstitucionesEffects {
    getInstituciones$ = createEffect(() =>
        this.actions$.pipe(
            ofType(GetInstituciones),
            switchMap(() =>
                this.apiService.getInstituciones().pipe(
                    map((instituciones: IInstituciones[]) => GetInstitucionesSuccess({ instituciones }))
                )
            )
        )
    );

    createInstituciones$ = createEffect(() =>
        this.actions$.pipe(
            ofType(CreateInstituciones),
            switchMap(payload =>
                this.apiService.createInstituciones(payload.institucion).pipe(
                    map((institucion: IInstituciones) => CreateInstitucionesSuccess({ institucion }))
                )
            )
        )
    );

    deleteInstituciones$ = createEffect(() =>
        this.actions$.pipe(
            ofType(DeleteInstituciones),
            switchMap(payload =>
                this.apiService.deleteInstituciones(payload.id).pipe(
                    map((institucion: IDeleteInstitucionesResponse) => DeleteInstitucionesSuccess({ institucion }))
                )
            )
        )
    );

    updateInstituciones$ = createEffect(() =>
        this.actions$.pipe(
            ofType(UpdateInstituciones),
            switchMap(payload =>
                this.apiService.updateInstituciones(payload.id, payload.institucion).pipe(
                    map((institucion: IUpdateInstitucionesResponse) => UpdateInstitucionesSuccess({ institucion }))
                )
            )
        )
    );

    constructor(
        private apiService: ApiService,
        private actions$: Actions,
        private store: Store<IAppState>
    ) { }
}
